import {
  CardTab,
  CodeSnippet,
  InfoCard,
  TabbedCard,
} from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import { IMessage } from '../../../schemas/IMessage.interface';

interface ExamplesSectionProps {
  examples: IMessage['examples'] | null;
}

function ExampleContent({ example }: { example: NonNullable<IMessage['examples']>[number] }) {
  return (
     <Box
        maxHeight="22rem"
        overflow="auto"
      >
        {example.summary && (
          <Typography variant="body2">{example.summary}</Typography>
        )}

        <CodeSnippet
          text={example.payload ? safeStringify(example.payload) : "No payload for this example"}
          language="json"
          showLineNumbers
        />
    </Box>
  );
}

function ExamplesSection({ examples }: ExamplesSectionProps) {
  if (!examples || examples.length === 0) {
    return (
      <InfoCard title="Examples">
        <Box
          height="22rem"
          overflow="auto"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography>No examples available</Typography>
        </Box>
      </InfoCard>
    );
  }

  return (
    <TabbedCard title="Examples">
      {(examples ?? []).map((example, index) => (
        <CardTab
          label={example.name
            ? `Example ${index + 1}: ${example.name}`
            : `Example ${index + 1}`}
        >
          <ExampleContent example={example} />
        </CardTab>
      ))}
    </TabbedCard>
  );
}

function safeStringify(payload: NonNullable<IMessage['examples']>[number]['payload']): string {
  try {
    return JSON.stringify(payload, null, 2);
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return `Error serializing payload: ${errorMessage}`;
  }
}

export { ExamplesSection };
